<template>
  <div>
    <h6 class="booking-details-title">{{ item.label }}</h6>
    <b-card bg-variant="light">
      <b-card-text style="white-space: pre-line;">
        {{ item.description }}
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'TransferItemInfo',
  props: ['item']
}
</script>
